var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-text-body-small"},[_c('span',[_vm._v("לא נרשמת בעבר? ")]),_c('link-button',{attrs:{"text":"כאן אפשר להירשם"},on:{"click":_vm.goToSignup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }